import { GridSpaceDataType, LevelType, SpaceType } from 'data/types';
import { collectLevelAutoLayoutSpaces } from 'utils/auto-layout-space';
import { collisionSpacesForUserMove } from 'utils/leftover-collision';

export type LeftoverRebuildTargets = {
  levelId: string;
  leftovers: SpaceType[];
};

function subjectIdList(
  subjectIds: ReadonlySet<string> | readonly string[]
): readonly string[] {
  return Array.isArray(subjectIds) ? subjectIds : [...subjectIds];
}

export function leftoverRebuildTargetsForLevel(
  level: LevelType | null | undefined,
  autoLayoutSpaceIds: readonly string[],
  subjectIds: ReadonlySet<string> | readonly string[]
): LeftoverRebuildTargets | null {
  if (!level) {
    return null;
  }
  const leftovers = collectLevelAutoLayoutSpaces(level, autoLayoutSpaceIds);
  if (leftovers.length === 0) {
    return null;
  }
  const leftoverIds = new Set(leftovers.map((space) => space.uniqueId));
  if (subjectIdList(subjectIds).some((id) => leftoverIds.has(id))) {
    return null;
  }
  return { levelId: level.uniqueId, leftovers };
}

export function leftoverUniqueIdsForLevel(
  level: LevelType | null | undefined,
  autoLayoutSpaceIds: readonly string[]
): Set<string> {
  if (!level) {
    return new Set();
  }
  return new Set(
    collectLevelAutoLayoutSpaces(level, autoLayoutSpaceIds).map(
      (space) => space.uniqueId
    )
  );
}

export function collisionSpacesForMove(
  spaces: GridSpaceDataType[],
  draggedIds: ReadonlySet<string>,
  level: LevelType | null | undefined,
  autoLayoutSpaceIds: readonly string[]
): GridSpaceDataType[] {
  return collisionSpacesForUserMove(
    spaces,
    draggedIds,
    leftoverUniqueIdsForLevel(level, autoLayoutSpaceIds)
  );
}

export function canPlaceIncomingSpaceOnRemainder(
  level: LevelType | null | undefined,
  autoLayoutSpaceIds: readonly string[]
): boolean {
  return leftoverRebuildTargetsForLevel(level, autoLayoutSpaceIds, []) !== null;
}
